import React from 'react'
import context from '@/context'
import { ModalBody, Form, FormGroup, Label } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { DropDownList } from '@/components/dropDownList'
import { DatePicker } from '@/components/DatePicker'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { CheckBox } from '@/components/CheckBox'
import getComponentKey from '@/utils/getComponentKey'
import { OrganizationalUnitSelector } from '@/components/organizationalUnitSelector'

class JobDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      ...props.job,
      jobPositionKey: getComponentKey()
    }
  }

  onOrganizationalUnitChange = ({ value }) => {
    this.setState({ organizationalUnit: value, jobPosition: null, jobPositionKey: getComponentKey() })
  }

  getOrganizationalUnitId = () => {
    let organizationalUnitId
    if (typeof this.state.organizationalUnit === 'object') {
      organizationalUnitId = this.state.organizationalUnit === null ? 0 : this.state.organizationalUnit.id || 0
    } else {
      organizationalUnitId = this.state.organizationalUnit
    }

    return organizationalUnitId
  }

  getDataSource = (request, options) => {
    return context.api.jobPositionService.getLookup(this.props.userId, this.props.job.id, this.getOrganizationalUnitId(), enhanceFilter(request), options)
  }

  onSave = () => {
    const input = {
      ...this.state,
      organizationalUnitId: this.getOrganizationalUnitId()
    }
    this.props.onAction(input)
  }
  render () {
    const props = this.props

    return (
      <ValidationBoundary>
        <BasicHeader title='JobPosition.Job' {...props} />
        <ModalBody>
          <ErrorBoundary>
            <Form>
              <FormGroup>
                <Label>{props.localize('JobPosition.OrganizationalUnit')}</Label>
                <Validator name='organizationalUnit' value={this.state.organizationalUnit} required>
                  <OrganizationalUnitSelector onChange={this.onOrganizationalUnitChange} value={this.getOrganizationalUnitId()} />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{props.localize('JobPosition.JobPositionTitle')}</Label>
                <Validator name='jobPosition' value={this.state.jobPosition} required>
                  <DropDownList
                    disabled={this.state.organizationalUnit === null}
                    key={this.state.jobPositionKey}
                    dataSource={this.getDataSource}
                    onChange={({ item }) => this.setState({ jobPosition: item })}
                    value={this.state.jobPosition}
                  />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{props.localize('Common.ValidFrom')}</Label>
                <Validator name='validFrom' value={this.state.validFrom} required>
                  <DatePicker
                    value={this.state.validFrom}
                    onChange={value => this.setState({ validFrom: value })} />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{props.localize('Common.ValidTo')}</Label>
                <DatePicker
                  value={this.state.validTo}
                  onChange={value => this.setState({ validTo: value })} />
              </FormGroup>
              <FormGroup>
                <CheckBox
                  id='acting'
                  label={props.localize('Common.Acting')}
                  checked={this.state.acting}
                  onChange={acting => this.setState({ acting })}
                />
              </FormGroup>
            </Form>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={this.onSave} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

function enhanceFilter (req) {
  if (req && req.filter && req.filter.filters.length === 1) {
    req.filter.logic = 'or'
    req.filter.filters.push({ field: 'code', operator: 'contains', value: req.filter.filters[0].value })
  }
  return req
}

export default {
  component: JobDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/job.js